<template>
  <div class="checkin">
    <h2>活动签到</h2>
    <p class="hint">请选择需要签到的订单，可按实际到场人数分次签到。</p>
    <el-table v-loading="loading" :data="orders" border>
      <el-table-column prop="order_no" label="订单号" min-width="180" />
      <el-table-column prop="activity_title" label="活动" min-width="160" />
      <el-table-column label="可签到" width="100"><template #default="s">{{ s.row.remaining_checkin_count }}</template></el-table-column>
      <el-table-column label="签到人数" width="160">
        <template #default="s"><el-input-number v-model="s.row._checkin_quantity" :min="1" :max="s.row.remaining_checkin_count" /></template>
      </el-table-column>
      <el-table-column label="操作" width="100"><template #default="s"><el-button type="primary" link @click="submit(s.row)">签到</el-button></template></el-table-column>
    </el-table>
    <el-empty v-if="!loading && orders.length === 0" description="暂无可签到订单" />
  </div>
</template>
<script>
import activity from '@/api/activity';
export default {
  name:'activityCheckinUser',
  data(){return{
    // 用户扫码后可签到订单列表。公共二维码只传 activity_id，订单归属由登录用户决定。
    loading:false,orders:[]
  }},
  created(){this.load();},
  methods:{
    // 查询当前用户该活动下已支付且未全部签到的订单。
    async load(){this.loading=true;const res=await activity.checkinOrders(this.$route.query.activity_id);if(res){this.orders=(res.data||[]).map(i=>({...i,_checkin_quantity:1}));}this.loading=false;},
    // 支持部分签到，提交人数不能超过订单剩余可签到人数。
    async submit(row){const res=await activity.checkin({order_id:row.id,quantity:row._checkin_quantity});if(res){this.$message.success(res.msg);this.load();}}
  }
};
</script>
<style scoped>.checkin{padding:30px}.checkin h2{margin:0 0 8px}.hint{color:#666;margin-bottom:20px}</style>
